var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "btn-close",
    attrs: { id: "btn-close", "aria-label": "close" },
    on: { click: _vm.closeBtnClicked },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }